<template>
    <div class="footer_sivoa">
        <div class="footer_container">

            <div class="contact_infos_space_line">
            </div>

            <div class="w3-row">
                <div class="w3-third w3-mobile">
                    <div class="w3-display-container" style="height:180px;">
                        <div class="w3-display-middle">
                            <img src="./images/FooterSivoa/pour_tous_renseignements.png" alt="pour_tous_renseignements" width="227px" height="58px" />
                        </div>
                    </div>
                </div>
                <div class="w3-third w3-mobile">
                    <div class="w3-display-container" style="height:180px;">
                        <div class="w3-display-middle">
                            <a href="mailto:animation@syndicatdelorge.fr?Subject=Inscriptions">
                                <img src="./images/FooterSivoa/contactez_nous_par_mail.png" alt="contactez_nous_par_mail" width="261px" height="58px" />
                            </a>
                        </div>
                    </div>
                </div>
                <div class="w3-third w3-mobile">
                    <div class="w3-display-container" style="height:180px;">
                        <div class="w3-display-middle">
                            <img src="./images/FooterSivoa/NVert_accueil.png" alt="contactez_nous_par_telephone" width="248px" height="58px" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="menu_adresses">
                <div class="w3-row w3-margin-bottom">
                    <div class="w3-half w3-left">
                        <router-link to="/management"><img src="./images/FooterSivoa/administration.svg" alt="administration" width="105px" height="20px"></router-link>
                        <a href="https://www.syndicatdelorge.fr/mentions-legales.html" style="margin-left: 16px;" target="_blank" class="menu_legal_notice">Mentions légales</a>
                    </div>
                    <div class="w3-half">
                        <img class="w3-right" src="./images/FooterSivoa/syndicat_orge_footer.png" alt="" />
                    </div>
                </div>

                <div class="menu_space_line">
                </div>

                <div class="w3-row">
                    <div class="w3-col l8 m6 s6 w3-margin-bottom">
                        <div class="w3-third w3-mobile">
                            <span id="text7">CYCLE 2</span>
                            <!-- TODO CL
                            <router-link to="/workshops_cycle_2"><div id="text8">FORMULAIRE ATELIERS CYCLE 2 (CP - CE1 - CE2)</div></router-link>
                            -->
                            <div id="text8">FORMULAIRE ATELIERS CYCLE 2 (CP - CE1 - CE2)</div>
                        </div>
                        <div class="w3-third w3-mobile">
                            <span id="text10">CYCLE 3</span>
                            <!-- TODO CL
                            <router-link to="/workshops_cycle_3"><div id="text11">FORMULAIRE ATELIERS CYCLE 3 (CM1 - CM2)</div></router-link>
                            -->
                            <div id="text11">FORMULAIRE ATELIERS CYCLE 3 (CM1 - CM2)</div>
                        </div>
                        <div class="w3-third w3-mobile">
                            <span id="text12">COLLÈGE</span>
                            <router-link to="/modules_college"><div id="text13">FORMULAIRE MODULES COLLÈGE</div></router-link>
                            <!-- TODO CL
                            <div id="text13">FORMULAIRE MODULES COLLÈGE</div>
                            -->
                        </div>
                    </div>
                    <div class="w3-rest w3-right">
                        <span class="w3-right" id="text14">ÉDUCATION A L'ENVIRONNEMENT</span><br />

                        <div class="w3-cell w3-cell-top" style="padding-right: 6px;">
                                <div class="w3-right" id="text15">SIÈGE SOCIAL</div><br/>
                                <div class="w3-right" id="text16">163, route de Fleury</div><br />
                                <div class="w3-right" id="text17">91172 Viry-Chatillon Cedex</div><br />
                        </div>
                        <div class="w3-cell menu_registration_pages_contact_infos_addresses_space_line">
                        </div>
                        <div class="w3-cell w3-cell-top" style="padding-left: 6px; padding-right: 6px;">
                                <div class="w3-right" id="text18">ANTENNE D'OLLAINVILLE</div><br />
                                <div class="w3-right" id="text19">19 rue de Saint-Arnoult</div><br />
                                <div class="w3-right" id="text20">91340 Ollainville</div><br />
                        </div>
                        <div class="w3-cell w3-block menu_registration_pages_contact_infos_addresses_space_line">
                        </div>

                        <div class="w3-right" style="padding-top: 34px;">
                            <img src="./images/FooterSivoa/NVert.png" alt="contactez_nous" width="150px" height="15px" />
                            <a href="https://www.syndicatdelorge.fr" target="_blank"><div id="text21" style="text-align: right;">syndicatdelorge.fr</div></a>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'footer_sivoa_vue'
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        text-decoration: none;
    }

    .footer_container {
    }

    .contact_infos_space_line {
        background-color: #009AA3;
        height: 1px;
    }

    .menu_adresses {
        background-color: #009AA3;
        padding-top: 15px;
        padding-right: 37px;
        padding-bottom: 37px;
        padding-left: 37px;
    }

    .menu_space_line {
        background-color: #FFFFFF;
        height: 1px;
    }

    .menu_registration_pages_contact_infos_addresses_space_line {
        background-color: #FFFFFF;
        width: 1px;
    }

    #text5 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 12px;
        color: #009AA3;
        padding: 10px;
    }

    #text4 {
        font-family: 'Roboto', sans-serif;
        font-weight: bold;
        font-size: 14px;
        color: #6C382A;
        padding: 10px;
    }

    #text6 {
        font-family: 'Roboto', sans-serif;
        font-weight: bold;
        font-size: 18px;
        color: #6C382A;
        padding: 10px;
    }

    #text7, #text10, #text12 {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 11px;
        color: #FFFFFF;
    }

    #text8, #text9, #text11, #text13 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 8px;
        color: #FFFFFF;
    }

    #text14 {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 13px;
        color: #FFFFFF;
    }

    #text15, #text18 {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 11px;
        color: #FFFFFF;
    }

    #text16, #text17, #text19, #text20 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 10px;
        color: #FFFFFF;
    }

    #text21 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 13px;
        color: #FFFFFF;
    }

    .menu_legal_notice {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 12px;
        color: #FFFFFF;
    }

</style>